export default __webpack_public_path__ + "static/media/scratch-card-image.8c2a2c42.svg";